import axiosInstance from './AxiosConfig';

export const fetchFederations = async () => {
  try {
    const response = await axiosInstance.get('/api/federaciones');
    return response.data;
  } catch (error) {
    console.error('Error al obtener las federaciones', error);
    throw error;
  }
}

export const fetchFederation = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/federaciones/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener la federación', error);
    throw error;
  }
}

export const updateFederation = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/api/federaciones/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener la federación', error);
    throw error;
  }
}
